/**
 * HPH Product Tabs
 * Desktop (>= 750px): horizontal tab switching.
 * Mobile (< 750px): accordion (expand/collapse panels independently).
 */

(function () {
  var MOBILE_BREAKPOINT = 750;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function initTabs(container) {
    var tabButtons = container.querySelectorAll('[data-hph-tab-btn]');
    var panels = container.querySelectorAll('[data-hph-tab-panel]');
    var accordionBtns = container.querySelectorAll('[data-hph-accordion-btn]');

    if (!panels.length) return;

    // Desktop: tab switching
    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-hph-tab-btn');

        tabButtons.forEach(function (b) {
          b.classList.remove('hph-tabs__btn--active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('hph-tabs__panel--active');
          p.setAttribute('hidden', '');
        });

        btn.classList.add('hph-tabs__btn--active');
        btn.setAttribute('aria-selected', 'true');

        var panel = container.querySelector('[data-hph-tab-panel="' + target + '"]');
        if (panel) {
          panel.classList.add('hph-tabs__panel--active');
          panel.removeAttribute('hidden');
        }
      });
    });

    // Mobile: accordion toggle
    accordionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-hph-tab-panel]');
        if (!panel) return;

        var isOpen = panel.classList.contains('hph-tabs__panel--open');

        if (isOpen) {
          panel.classList.remove('hph-tabs__panel--open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          panel.classList.add('hph-tabs__panel--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Activate first tab on desktop, first accordion on mobile
    if (!isMobile() && tabButtons[0]) {
      tabButtons[0].click();
    } else if (isMobile() && panels[0]) {
      panels[0].classList.add('hph-tabs__panel--open');
      var firstAccordionBtn = panels[0].querySelector('[data-hph-accordion-btn]');
      if (firstAccordionBtn) firstAccordionBtn.setAttribute('aria-expanded', 'true');
    }
  }

  function init() {
    document.querySelectorAll('[data-hph-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify section rendering (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
